/**
 * `shell` translations, for every locale.
 */
export const shell = {
  mn: {
      app: { title: 'CenTrig', signOut: 'Гарах', signOutMicrosoft: 'Microsoft-оос ч гарах', signOutChoiceBody: 'Зөвхөн энэ програмаас гарах уу, эсвэл Microsoft-оос (Outlook, вэб дээрх Teams) ч гарах уу?', sessionCheckFailed: 'Сервертэй холбогдож чадсангүй. Таны нэвтрэлт хэвээр байна, хуудас ажиллаж байна.', sessionCheckRetry: 'Дахин оролдох', apiDownTitle: 'Сервертэй холбогдож чадсангүй', apiDownBody: 'Та Microsoft-оор нэвтэрсэн боловч CenTrig API хариу өгсөнгүй. Энэ нь таны бүртгэлийн асуудал биш, сервер эсвэл холболтын асуудал юм. Бэкэнд ажиллаж байгаа эсэхийг шалгаад дахин оролдоно уу.', sales: 'Борлуулалт', clients: 'Харилцагч', priceList: 'Үнийн жагсаалт', activityExpense: 'Үйл ажиллагааны сан', requests: 'Хүсэлтүүд', trips: 'Томилолт', users: 'Хэрэглэгчид', salesDocuments: 'Баримтууд',
        timeLogging: 'Цагийн бүртгэл', contractorLog: 'Гэрээт ажилтны бүртгэл', leave: 'Чөлөө', hotDesk: 'Ажлын байр захиалга', calendar: 'Хуанли',
        mySalary: 'Миний цалин', myInfo: 'Миний мэдээлэл', mySupervisor: 'Миний шууд удирдлага', myEquipment: 'Миний тоног төхөөрөмж',
        inventory: 'Хөрөнгө', laptops: 'Компьютер',
        adminActivities: 'Жагсаалтууд', adminCalendar: 'Баярын хуанли', adminChanges: 'Өөрчлөлтийн бүртгэл',
        adminActions: 'Хийсэн үйлдлүүд', adminPersonTrail: 'Хүний ул мөр',
        adminAudit: 'Аудит',
        adminAuditLog: 'Цалингийн хандалт', adminAutomation: 'Автоматжуулалт', adminOrganization: 'Байгууллагын тохиргоо',
        organization: 'Байгууллага', hr: 'Хүний нөөц',
        me: 'Миний самбар',
        dashboard: 'Хяналтын самбар',
        roster: 'Ээлжийн хуваарь', schedule: 'Хуваарь', rosterPeople: 'Ажилтнууд', bus: 'Автобус', hse: 'ХАБЭА', performance: 'Гүйцэтгэл', cost: 'Зардал', rosterSetup: 'Төслүүд', rosterMySchedule: 'Миний хуваарь',
        payroll: 'Цалин', salary: 'Цалин тооцоо' },
      dashboard: {
        last12: 'Сүүлийн 12 сар', noData: 'Мэдээлэл алга',
        myAnnualLeave: 'Ээлжийн амралт', daysRemaining: 'үлдсэн хоног',
        needsMe: 'Цагийн бүртгэлд засвар хэрэгтэй', needsMeHint: 'буцаасан өдөр, илгээгээгүй ноорог -- зөвшөөрлийн дараалал биш',
        myPendingLeave: 'Хүлээгдэж буй чөлөө',
        myAwaiting: 'Батлах чөлөө',
        myLeaves: 'Чөлөөний үлдэгдэл',
        myPendingRejected: 'Хүлээгдэж буй, буцаасан бүртгэл',
        superviseeHoursAwaiting: 'Харьяа ажилтны батлах цаг',
        pendingRequests: 'Миний худалдан авах хүсэлт',
        myDesk: 'Өнөөдрийн ширээ',
        myTimesheet: 'Миний цагийн бүртгэл', thisMonth: 'Энэ сар', payrollPeriod: 'Цалингийн үе',
        approved: 'Батлагдсан', pending: 'Хүлээгдэж буй', draft: 'Ноорог', rejected: 'Татгалзсан', missing: 'Бүртгээгүй',
        weekend: 'Амралтын өдөр', holiday: 'Баярын өдөр',
        ofWorkingDays: 'Нийт {{count}} ажлын өдрөөс',
        ofPeriodDays: 'Нийт {{count}} өдрөөс ({{date}}-с хойш)',
        myHoursByActivity: 'Үйл ажиллагаагаар', myHoursByProduct: 'Бүтээгдэхүүнээр',
        myOpenItems: 'Миний бусад ажил', draftSales: 'Ноорог борлуулалт', unapprovedTrips: 'Батлагдаагүй томилолт',
        activeStaff: 'Идэвхтэй ажилтан', inactiveCount: '{{count}} идэвхгүй',
        unapprovedDays: 'Батлагдаагүй өдөр', oldestDays: 'хамгийн эртнийх {{count}} хоног', unapprovedBand: '{{band}} хоног', unapprovedHelp: 'Илгээгдсэн боловч батлагдаагүй бүх өдөр, хэдэн ч хоногийн настай байсан.', unapprovedOpenQueue: 'Бүх ажилтны батлах дараалал',
        uncoveredProducts: 'Хариуцагчгүй бүтээгдэхүүн', uncoveredHint: 'хэн ч томилогдоогүй',
        uncoveredList: 'Хариуцагчгүй: {{list}}',
        workModeNow: 'Өнөөдрийн ажлын горим',
        genderRatio: 'Хүйсийн харьцаа', genderFullTime: 'Бүтэн цаг',
        hoursByProduct: 'Бүтээгдэхүүнээр зарцуулсан цаг', thisMonthCompany: 'Энэ сар, бүх ажилтан',
        byTeam: 'Багаар', byWorkType: 'Ажлын хэлбэрээр',
        productCoverage: 'Бүтээгдэхүүний хамрах хүрээ', productCoverageHint: 'Томилогдсон хүний тоо', chartOther: 'Бусад',
        roleMix: 'Үүргийн бүтэц',
      },
      notifications: {
        myTitle: 'Миний мэдэгдэл', hint: 'Танд ирсэн автомат мэдэгдлийн түүх',
        empty: 'Мэдэгдэл алга', error: 'Мэдэгдэл ачаалахад алдаа гарлаа', markAllRead: 'Бүгдийг уншсан болгох',
        unreadCount: '{{count}} уншаагүй', loadMore: 'Цааш ачаалах',
        popupTitle: 'Шинэ мэдээ', popupViewAll: 'Бүгдийг харах', popupDismiss: 'Хаах', morePeople: '+{{count}} хүн',
        kind: {
          invoice_due_soon: '{{organization}}-ийн {{document_no}} нэхэмжлэх {{due_date}}-нд төлөгдөх хугацаатай ({{total}} {{currency}})',
          invoice_overdue: '{{organization}}-ийн {{document_no}} нэхэмжлэхийн хугацаа хэтэрсэн (төлөх хугацаа {{due_date}} байсан)',
          contract_end_soon: '{{name}}-ийн гэрээ {{end_of_contract}}-нд дуусна',
          contract_end_past: '{{name}}-ийн гэрээ {{end_of_contract}}-нд дууссан',
          hr_welcome: '{{first_name}}-г угтъя — {{worked_since}}-нээс ажилд орлоо',
          hr_anniversary: '{{name}}-ийн ажилласан {{years}} жилийн ой',
          hr_birthday: '{{name}}-ийн төрсөн өдөр',
          supervisor_changed: '{{name}}-ийн шууд удирдлага {{previous_supervisor}}-с {{new_supervisor}} болж өөрчлөгдлөө',
          staff_joined: '{{name}} компанид ажилд орлоо',
          staff_left: '{{name}} компаниас гарлаа',
          request_submitted: '{{prepared_by}}-ийн илгээсэн {{type_of}}: {{purpose}} ({{total}} {{currency}})',
          request_decided: '{{type_of}} "{{purpose}}" хүсэлтийг {{editor}} {{approval_status}}',
          equipment_request_decided: 'Таны тоног төхөөрөмжийн хүсэлт: {{status}} ({{decided_by}})',
          request_self_approved: '{{editor}} өөрийн {{type_of}} "{{purpose}}" хүсэлтийг өөрөө баталлаа ({{total}} {{currency}})',
          request_sent: '{{editor}} {{prepared_by}}-ийн {{type_of}} "{{purpose}}" хүсэлтийг илгээлээ ({{total}} {{currency}})',
          timesheet_needs_approval: 'Дэд ажилтны цагийн бүртгэл баталгаажуулах хүлээгдэж байна',
          timesheet_rejected: 'Таны цагийн бүртгэлийн мөр цуцлагдлаа',
          timesheet_rejected_day: '{{date}}-ний цагийн бүртгэл тань цуцлагдлаа',
          timesheet_rejected_expired: '{{date}}-ний цагийн бүртгэл тань хугацаандаа батлагдаагүй тул системээр автоматаар цуцлагдлаа',
          timesheet_rejected_more: 'Өөр {{more}} цагийн бүртгэлийг татгалзсан, хамгийн эртнийх нь {{date}}',
          timesheet_office_solo_late: '{{actor}} {{name}}-ийн {{day}}-ний хоцорсон цагийн бүртгэлийг хамтран батлахгүйгээр ганцаараа өөрчиллөө',
          timesheet_past_edit: '{{actor}} {{name}}-ийн {{day}}-ний өнгөрсөн цагийн бүртгэлийг зассан',
          timesheet_late_submitted: '{{name}} {{day}}-ний бүртгэлээ {{period}}-ийн хаалтын огнооноос хойш батлуулахаар илгээсэн ({{hours}} ц), {{paid_in}}-д олгоно',
          timesheet_past_edit_mailed: '{{name}}-ийн {{day}}-ний цагийн засварын мэдэгдэл и-мэйлээр илгээгдлээ: {{recipients}}',
          salary_cutoff_pending: 'Цалингийн бодолт хаагдах {{cutoff_date}}-с өмнө илгээгээгүй цаг байна',
          salary_cutoff_last_day: '{{cutoff_date}}-ний цалингийн бодолтод цаг оруулах хугацаа өнөөдөр 12:00 цагт дуусна',
          timesheet_approval_deadline: '{{cutoff_date}}-ний цалингийн бодолтын дэд ажилтны хүлээгдэж буй цагийг өнөөдөр баталгаажуулна уу',
          timesheet_pending_at_close: '{{cutoff_date}}-ний цалингийн бодолтод {{pending_count}} өдөр баталгаажаагүй хэвээр байна',
          timesheet_weekly_reminder: 'Энэ долоо хоногийн цагаа бүртгэнэ үү',
          annual_leave_unused: 'Заавал авах ээлжийн амралтаа хараахан аваагүй байна',
          leave_break_ending: '{{employee_name}}-ийн {{leave_type}} {{end_date}}-нд дуусна (долоо хоногийн дараа)',
          leave_break_starting: '{{employee_name}} {{leave_type}}-ийн улмаас {{start_date}}-наас {{end_date}} хүртэл завсарлагаанд гарна',
          leave_approval_pending: 'Чөлөөний хүсэлт таны зөвшөөрлийг хүлээж байна',
          leave_submitted: '{{employee_name}} {{leave_type}} хүсэлт илгээлээ: {{start_date}}–{{end_date}} ({{days}} өдөр)',
          leave_decided: 'Таны {{leave_type}} хүсэлт ({{start_date}}–{{end_date}}) {{decided_by}}-ээр {{status}}',
          leave_peer_blocked: 'Таны {{leave_type}} {{start_date}}–{{end_date}} хүсэлт татгалзагдлаа: {{peer_name}} {{peer_start}}–{{peer_end}} чөлөөтэй ({{peer_status}})',
          leave_peer_clash: '{{applicant_name}}-ийн {{leave_type}} {{start_date}}–{{end_date}} хүсэлт таны {{peer_start}}–{{peer_end}} чөлөөтэй давхцсан тул татгалзагдлаа',
          leave_rule_overridden: '{{overridden_by}} {{employee_name}}-ийн {{leave_type}} {{start_date}}–{{end_date}}-д "{{rule}}" дүрмийг давлаа: {{reason}}',
          leave_cancel_refused: 'Таны {{leave_type}} {{start_date}}–{{end_date}} цуцлах хүсэлтийг {{decided_by}} татгалзлаа',
          leave_cancelled: '{{cancelled_by}} {{employee_name}}-ийн {{leave_type}} {{start_date}}–{{end_date}} хүсэлтийг цуцаллаа; таны баталгаа шаардлагагүй боллоо',
          leave_settlement_decided: 'Таны чөлөөний тооцоо ({{requested_days}} өдөр)-г {{decided_by}} {{status}} болголоо',
          leave_auto_rejected: 'Таны {{leave_type}} {{start_date}}–{{end_date}} хүсэлт хоёр цалингийн үеэс хэтэрсэн тул автоматаар татгалзагдлаа',
          overwork_14_days: '{{name}} 14 хоног амралтгүй ажиллаж байна',
          resignation_today: '{{name}} өнөөдөр ({{resignation_date}}) компаниас гарч байна',
          salary_cutoff_reminder: 'Цалингийн бодолт {{cutoff_date}}-нд хаагдана',
          salary_cutoff_moved: 'Цалингийн бодолт хаагдах огноо {{previous_cutoff_date}}-с {{cutoff_date}} болж өөрчлөгдлөө',
          salary_cutoff_closed: '{{cutoff_date}}-ний цалингийн бодолтод цаг оруулах хугацаа дууслаа; илгээсэн цагийг өнөөдөр баталгаажуулж болно; цалин {{pay_date}}-нд олгоно',
          leave_override_granted: '{{granted_by}} танд чөлөөний дүрмээс зөвшөөрөл олголоо: {{reason}}',
          approval_backlog_escalation: 'Хугацаа хэтэрсэн баталгаажуулалт дээд шатанд шилжлээ',
          approval_backlog_digest: '{{row_count}} баталгаажуулалт хугацаанаасаа хэтэрч хүлээгдэж байна',
          approval_backlog_digest_both: '{{time_count}} цагийн бүртгэл, {{leave_count}} чөлөөний хүсэлт хугацаанаасаа хэтэрч хүлээгдэж байна',
          approval_backlog_digest_time: '{{time_count}} цагийн бүртгэл хугацаанаасаа хэтэрч хүлээгдэж байна',
          approval_backlog_digest_leave: '{{leave_count}} чөлөөний хүсэлт хугацаанаасаа хэтэрч хүлээгдэж байна',
          timesheet_backlog_expired: '{{people}} хүний {{count}} өдрийн цагийн бүртгэлийг хугацаа хэтэрсэн тул автоматаар татгалзлаа',
          roster_departure_soon: 'Та {{start_date}}-нд {{project}} руу явна ({{days_until}} хоногийн дараа)',
          roster_plan_changed: 'Таны нийтлэгдсэн хуваарь {{change_count}} өдөр өөрчлөгдлөө ({{first_day}} — {{last_day}})',
          oreas_request_received: '{{company}}-с шинэ OREAS хүсэлт ирлээ: {{products}}',
          oreas_request_resolved: '{{decided_by}} {{company}}-ийн OREAS хүсэлтээр ноорог үнийн санал гаргалаа',
          unknown: 'Шинэ мэдэгдэл ирлээ',
        },
        why: {
          actor: 'Та энэ өөрчлөлтийг хийсэн тул танд ирлээ.',
          ability: 'Танд «{{label}}» эрх байгаа тул ирлээ.',
          level: 'Та {{level}} хандалтын түвшинд байгаа тул ирлээ.',
          subject: {
            aboutYou: 'Энэ таны тухай тул танд ирлээ.',
            oreasHolder: 'Та OREAS эрхтэй эсвэл энэ үнийн саналтай холбоотой тул танд ирлээ.',
            yourRequest: 'Та үүнийг илгээсэн тул танд ирлээ.',
            youApprove: 'Та үүнийг баталгаажуулдаг тул танд ирлээ.',
            newSupervisor: 'Та шинэ шууд удирдлага болсон тул танд ирлээ.',
            overlap: 'Энэ таны чөлөөтэй давхцаж байгаа тул танд ирлээ.',
            applicantOrOverlap: 'Энэ таны чөлөө, эсвэл таны чөлөөтэй давхцаж байгаа тул танд ирлээ.',
            overwork: 'Энэ таны эсвэл таны удирддаг хүний тухай тул танд ирлээ.',
            logsHours: 'Та цагаа бүртгэдэг тул танд ирлээ.',
            pastEdit: 'Энэ таны бүртгэл, эсвэл та бүртгэл баталгаажуулдаг тул танд ирлээ.',
          },
        },
        open: 'Нээх', sentBy: 'Илгээсэн дүрэм',
        digestTime: 'Цагийн бүртгэл ({{n}})', digestLeave: 'Чөлөө ({{n}})',
        field: {
          leaveType: 'Чөлөөний төрөл', statusBefore: 'Өмнөх төлөв', decidedBy: 'Шийдвэрлэсэн', rejectedBy: 'Татгалзсан',
          changedBy: 'Өөрчилсөн', reason: 'Шалтгаан', days: 'Хоног', cutoffDate: 'Хаагдах огноо', payDate: 'Олгох огноо',
          hours: 'Цаг', before: 'Өмнө', after: 'Дараа', recipients: 'Хүлээн авагчид', endOfContract: 'Гэрээ дуусах',
          resignationDate: 'Гарах огноо', previousSupervisor: 'Өмнөх шууд удирдлага', newSupervisor: 'Шинэ шууд удирдлага',
          project: 'Төсөл', grantedBy: 'Олгосон', rule: 'Чөлөөний дүрэм',
          peerLeaveType: 'Аль хэдийн бүртгэгдсэн чөлөө', settlementFor: 'Тооцооны үндэслэл', request: 'Хүсэлт',
          daysRemaining: 'Үлдсэн хоног', daysSinceEnd: 'Дууснаас хойш хоног',
        },
      },
      soon: { title: '{{app}} — удахгүй', body: '{{replaces}}-г орлоно. Энэ хэсгийн хуудсууд бэлтгэгдэж байна.', module: 'Энэ модуль хараахан бэлэн болоогүй байна.' },
      month: { jan: '1-р сар', feb: '2-р сар', mar: '3-р сар', apr: '4-р сар', may: '5-р сар', jun: '6-р сар', jul: '7-р сар', aug: '8-р сар', sep: '9-р сар', oct: '10-р сар', nov: '11-р сар', dec: '12-р сар' },
      weekday: { mon: 'Да', tue: 'Мя', wed: 'Лх', thu: 'Пү', fri: 'Ба', sat: 'Бя', sun: 'Ня' },
      theme: { label: 'Загвар', light: 'Цайвар', dark: 'Бараан', system: 'Систем' },
      profile: {
        title: 'Профайл', name: 'Нэр', email: 'И-мэйл', accessLevel: 'Хандах эрхийн түвшин',
        language: 'Хэл',
        signatureHint: 'Таны гарын үсэг зурсан баримтад ашиглагдана.',
        signatureAbsent: 'Гарын үсэг оруулаагүй байна.', signatureUpload: 'Гарын үсэг оруулах',
        signatureReplace: 'Солих', signatureRemove: 'Устгах',
        signatureForbidden: 'Энэ гарын үсгийг харах эрхгүй байна.',
        signatureBadType: 'Зөвхөн PNG эсвэл JPEG файл байх ёстой.',
        signatureHeic: 'iPhone-ийн HEIC зургийг дэмжихгүй: дэлгэцийн зураг авах эсвэл PNG/JPEG болгон экспортлоно уу.',
        signatureEmpty400: 'Файл хоосон байна.',
        signatureTooLarge: 'Файл хэт том байна (12 МБ-аас их). Жижиг зураг сонгоно уу — том зургийг систем өөрөө жижигрүүлнэ.',
        signatureModeDraw: 'Зурж оруулах',
        signatureClear: 'Цэвэрлэх', signatureSave: 'Хадгалах',
        signatureEmpty: 'Эхлээд гарын үсгээ зурна уу.',
        signatureSlotAll: 'Бүх төрлийн баримт',
        signatureSlotsHint: 'Бүх баримтад нэг, эсвэл баримтын төрөл бүрт тусад нь оруулж болно. Баримтын өөрийн төрлийнх эхэлж хэрэглэгдэнэ.',
        signatureSlotFor: 'Аль баримтад',
        signatureSlotTaken: 'Энэ төрөлд гарын үсэг байна — шинийг оруулбал солигдоно. Өмнө гаргасан баримтууд хуучнаа хадгална.',
        mySignature: 'Миний гарын үсэг',
        // The signature switch.
        signatureSwitch: 'Баримтад гарын үсгээ зурах',
        signatureSwitchOffHint:
          'Унтраалттай: таны гаргах баримтад гарын үсгийн хоосон мөр хэвлэгдэнэ. Өмнө гаргасан баримтууд гарын үсгээ хадгална. Зураг устахгүй.',
        elevateTitle: 'Түр зуурын админ эрх',
        elevateHint:
          'Админтай холбогдох боломжгүй бол та өөртөө тодорхой хугацаанд админ эрх өгч болно. Хугацаа нь өөрөө дуусна, эрхээ хугацаанаас нь эрт буцааж болно, мөн тэр эрхээр хийсэн үйлдэл бүр бүртгэгдэнэ.',
        elevateMinutes: 'Хэр хугацаагаар, минутаар',
        elevateMinutesHint: 'Хамгийн ихдээ {{max}} минут ({{hours}} цаг). Өгөгдмөл хугацаа байхгүй — та өөрөө сонгоно.',
        elevateReason: 'Шалтгаан',
        elevateReasonHint: 'Хамгийн багадаа {{min}} тэмдэгт. Эрхийн бүртгэлд хадгалагдаж, аудитад харагдана.',
        elevateButton: 'Өөртөө админ эрх өгөх',
        elevateConfirmTitle: 'Өөртөө админ эрх өгөх үү?',
        elevateConfirmBody: 'Та {{minutes}} минутын турш админ эрхтэй болно, дараа нь эрх өөрөө хүчингүй болно.',
        elevateConfirmAudited: 'Энэ үйлдэл таны бичсэн шалтгаантай хамт аудитад бүртгэгдэнэ. Эрхээ хүссэн үедээ буцааж болно.',
        elevateConfirmOk: 'Тийм, эрх өгөх',
        elevateActive: 'Та {{until}} хүртэл түр зуурын админ эрхтэй байна.',
        elevateRemaining: '{{count}} минут үлдсэн',
        elevateActiveReason: 'Бичсэн шалтгаан: {{reason}}',
        elevateRevoke: 'Эрхээ одоо буцаах',
        elevateGranted: 'Та түр зуурын админ эрхтэй болсон.',
        elevateRevoked: 'Админ эрхийг буцаалаа.',
      },
      nav: {
        groupInfo: 'Мэдээлэл', groupWork: 'Ажил', groupFinance: 'Санхүү', groupAdmin: 'Админ',
        expand: 'Цэсийг тогтоох', collapse: 'Цэсийг хураах',
        timeAwaiting: 'Таны батлахыг хүлээж буй {{count}} өдрийн цагийн бүртгэл',
        leaveAwaiting: 'Таны шийдвэрийг хүлээж буй {{count}} чөлөөний хүсэлт',
        oreasAwaiting: 'Таны хариуг хүлээж буй {{count}} OREAS хүсэлт, нөөцийн асуулт',
        notificationsUnread: '{{count}} уншаагүй мэдэгдэл',
      },
      action: {
        save: 'Хадгалах',
        moreAbout: '{{label}}: тайлбар',
        loading: 'Ачаалж байна…',
        saveDraft: 'Ноорог',
        preview: 'Урьдчилан харах',
        refresh: 'Шинэчлэх',
        convert: 'Нэхэмжлэх болгох',
        clearFilters: 'Шүүлтүүрийг арилгах',
        collapse: 'Хураах',
        download: 'PDF татах',
        void: 'Хүчингүй болгох',
        delete: 'Устгах',
        confirmDelete: 'Устгах уу?',
        deleteNamed: '"{{name}}"-г устгах уу?',
        edit: 'Засах',
        cancel: 'Болих',
        back: 'Буцах',
        newDocument: 'Шинэ баримт',
        showList: 'Жагсаалтыг харуулах',
        search: 'Хайх',
        close: 'Хаах',
        copy: 'Хуулах',
      },
      validation: {
        required: 'заавал',
        summaryTitle: 'Дараах талбарыг бөглөнө үү:',
        needLine: 'Дор хаяж нэг мөр нэмнэ үү',
        itemDesc: 'Мөр {{rows}}: утга оруулна уу',
        enterClientInfo: 'Харилцагчийн мэдээллийг оруулна уу',
      },
      notImplemented: 'Энэ хэсэг хараахан бэлэн болоогүй байна.',
      // The root ErrorBoundary's fallback, after a deploy leaves an
      // open tab's chunk 404ing and the one-time auto-reload did not clear it.
      error: { title: 'Энэ хуудас ажиллахаа больсон', pageStopped: '{{page}} ажиллахаа больсон', next: 'Хуудсыг дахин ачаалж оролдоно уу. Дахин гарвал доорх дэлгэрэнгүйг администраторт илгээнэ үү.', details: 'Алдааны дэлгэрэнгүй', reload: 'Дахин ачаалах' },
  },
  en: {
      app: { title: 'CenTrig', signOut: 'Sign out', signOutMicrosoft: 'Also sign out of Microsoft', signOutChoiceBody: 'Sign out of this app only, or of Microsoft too (Outlook and Teams on the web)?', sessionCheckFailed: 'Could not reach the server. You are still signed in and nothing on this page was lost.', sessionCheckRetry: 'Retry', apiDownTitle: 'Cannot reach the server', apiDownBody: 'You are signed in with Microsoft, but the CenTrig API did not respond. This is a server or connection problem, not a problem with your account. Check that the backend is running, then retry.', sales: 'Sales', clients: 'Clients', priceList: 'Price list', activityExpense: 'Activity fund', requests: 'Requests', trips: 'Business trips', users: 'Users', salesDocuments: 'Documents',
        timeLogging: 'Time logging', contractorLog: 'Contractor log', leave: 'Leave', hotDesk: 'Hot desk', calendar: 'Calendar',
        mySalary: 'My salary', myInfo: 'My info', mySupervisor: 'My supervisor', myEquipment: 'My equipment',
        inventory: 'Inventory', laptops: 'Laptops',
        adminActivities: 'Activities & lists', adminCalendar: 'Holiday calendar', adminChanges: 'Change record',
        adminActions: 'Admin actions', adminPersonTrail: 'Person audit trail',
        adminAudit: 'Audit',
        adminAuditLog: 'Payroll access', adminAutomation: 'Automation', adminOrganization: 'Organization settings',
        organization: 'Organization', hr: 'HR',
        me: 'My Panel',
        dashboard: 'Dashboard',
        roster: 'Roster', schedule: 'Schedule', rosterPeople: 'People', bus: 'Bus', hse: 'HSE', performance: 'Performance', cost: 'Cost', rosterSetup: 'Projects', rosterMySchedule: 'My schedule',
        payroll: 'Payroll', salary: 'Salary' },
      dashboard: {
        last12: 'Last 12 months', noData: 'No data yet',
        myAnnualLeave: 'My annual leave', daysRemaining: 'days remaining',
        needsMe: 'My timesheet needs fixing', needsMeHint: 'rejected days, unsubmitted drafts -- not an approval queue',
        myPendingLeave: 'My pending leave',
        myAwaiting: 'Leave to approve',
        myLeaves: 'Leave balance',
        myPendingRejected: 'Pending & rejected logs',
        superviseeHoursAwaiting: 'Pending supervisee logs',
        pendingRequests: 'Pending purchase requests',
        myDesk: "Today's desk",
        myTimesheet: 'My timesheet', thisMonth: 'This month', payrollPeriod: 'Payroll period',
        approved: 'Approved', pending: 'Pending', draft: 'Draft', rejected: 'Rejected', missing: 'Not logged',
        weekend: 'Weekend', holiday: 'Holiday',
        ofWorkingDays: 'Of {{count}} working days so far',
        ofPeriodDays: 'Of {{count}} days since {{date}}',
        myHoursByActivity: 'My hours by activity', myHoursByProduct: 'My hours by product',
        myOpenItems: 'My other open items', draftSales: 'Draft sales', unapprovedTrips: 'Unapproved trips',
        activeStaff: 'Active staff', inactiveCount: '{{count}} inactive',
        unapprovedDays: 'Unapproved days', oldestDays: 'oldest {{count}} day(s) back', unapprovedBand: '{{band}} days', unapprovedHelp: 'Every submitted day still unapproved, at any age.', unapprovedOpenQueue: "Everyone's approvals queue",
        uncoveredProducts: 'Uncovered products', uncoveredHint: 'nobody assigned',
        uncoveredList: 'Nobody is assigned to: {{list}}',
        workModeNow: 'Work modes today',
        genderRatio: 'Gender ratio', genderFullTime: 'Full-time',
        hoursByProduct: 'Hours by product', thisMonthCompany: 'This month, everyone',
        byTeam: 'By team', byWorkType: 'By work type',
        productCoverage: 'Product coverage', productCoverageHint: 'People assigned', chartOther: 'Other',
        roleMix: 'Role mix',
      },
      notifications: {
        myTitle: 'My notifications', hint: 'History of automated notices addressed to you',
        empty: 'No notifications yet', error: 'Could not load notifications', markAllRead: 'Mark all read',
        unreadCount: '{{count}} unread', loadMore: 'Load more',
        popupTitle: "What's new", popupViewAll: 'View all', popupDismiss: 'Dismiss', morePeople: '+{{count}} more',
        kind: {
          invoice_due_soon: 'Invoice {{document_no}} for {{organization}} ({{total}} {{currency}}) is due {{due_date}}',
          invoice_overdue: 'Invoice {{document_no}} for {{organization}} is overdue (was due {{due_date}})',
          contract_end_soon: "{{name}}'s contract ends {{end_of_contract}}",
          contract_end_past: "{{name}}'s contract ended {{end_of_contract}}",
          hr_welcome: 'Welcome {{first_name}} — started {{worked_since}}',
          hr_anniversary: "{{name}}'s {{years}}-year work anniversary",
          hr_birthday: "It's {{name}}'s birthday",
          supervisor_changed: "{{name}}'s supervisor changed from {{previous_supervisor}} to {{new_supervisor}}",
          staff_joined: '{{name}} has joined the company',
          staff_left: '{{name}} has left the company',
          request_submitted: '{{type_of}} submitted by {{prepared_by}}: {{purpose}} ({{total}} {{currency}})',
          request_decided: '{{type_of}} "{{purpose}}" was {{approval_status}} by {{editor}}',
          equipment_request_decided: 'Your equipment request: {{status}} by {{decided_by}}',
          request_self_approved: '{{editor}} approved their own {{type_of}} "{{purpose}}" ({{total}} {{currency}})',
          request_sent: `{{editor}} sent {{prepared_by}}'s {{type_of}} "{{purpose}}" ({{total}} {{currency}})`,
          timesheet_needs_approval: "Supervisees' timesheets are waiting on your approval",
          timesheet_rejected: 'Your timesheet entry was rejected',
          timesheet_rejected_day: 'Your time log for {{date}} was rejected',
          timesheet_rejected_expired: 'Your time log for {{date}} was not approved in time and the system rejected it automatically',
          timesheet_rejected_more: '{{more}} more time logs were rejected, the oldest on {{date}}',
          timesheet_office_solo_late: "{{actor}} changed {{name}}'s late day {{day}} alone, without the co-approvals",
          timesheet_past_edit: "{{actor}} corrected {{name}}'s past time log for {{day}}",
          timesheet_late_submitted: '{{name}} sent {{day}} ({{hours}} h) for approval after the {{period}} cut-off; paid in {{paid_in}}',
          timesheet_past_edit_mailed: "Notification email about your correction of {{name}}'s {{day}} sent to: {{recipients}}",
          salary_cutoff_pending: 'You have hours not yet sent before the {{cutoff_date}} cut-off',
          salary_cutoff_last_day: 'Time entry for the {{cutoff_date}} payroll closes at 12:00 today',
          timesheet_approval_deadline: "Approve your supervisees' pending days for the {{cutoff_date}} payroll today",
          timesheet_pending_at_close: '{{pending_count}} days are still pending for the {{cutoff_date}} payroll',
          timesheet_weekly_reminder: 'Log your hours for this week',
          annual_leave_unused: "You haven't taken your mandatory annual leave yet",
          leave_break_ending: "{{employee_name}}'s {{leave_type}} ends on {{end_date}}, a week from now",
          leave_break_starting: '{{employee_name}} goes on break from {{start_date}} to {{end_date}}: {{leave_type}}',
          leave_approval_pending: 'A leave request is waiting on your approval',
          leave_submitted: '{{employee_name}} submitted {{leave_type}}: {{start_date}}–{{end_date}} ({{days}} day(s))',
          leave_decided: 'Your {{leave_type}} ({{start_date}}–{{end_date}}) was {{status}} by {{decided_by}}',
          leave_peer_blocked: 'Your {{leave_type}} {{start_date}}–{{end_date}} was refused: {{peer_name}} is on leave {{peer_start}}–{{peer_end}} ({{peer_status}})',
          leave_peer_clash: "{{applicant_name}}'s {{leave_type}} {{start_date}}–{{end_date}} was refused because it overlaps your leave {{peer_start}}–{{peer_end}}",
          leave_rule_overridden: '{{overridden_by}} overrode the "{{rule}}" rule for {{employee_name}}\'s {{leave_type}} {{start_date}}–{{end_date}}: {{reason}}',
          leave_cancel_refused: 'Your request to withdraw {{leave_type}} {{start_date}}–{{end_date}} was rejected by {{decided_by}}',
          leave_cancelled: "{{cancelled_by}} cancelled {{employee_name}}'s {{leave_type}} {{start_date}}–{{end_date}}; it no longer needs your approval",
          leave_settlement_decided: 'Your leave settlement ({{requested_days}} days) was {{status}} by {{decided_by}}',
          leave_auto_rejected: 'Your {{leave_type}} {{start_date}}–{{end_date}} was rejected automatically: more than two pay periods have passed',
          overwork_14_days: '{{name}} has logged hours 14 days straight with no rest day',
          resignation_today: '{{name}} leaves the company today ({{resignation_date}})',
          salary_cutoff_reminder: 'The salary cut-off is {{cutoff_date}}',
          salary_cutoff_moved: 'The salary cut-off moved from {{previous_cutoff_date}} to {{cutoff_date}}',
          salary_cutoff_closed: 'Time entry for the {{cutoff_date}} payroll has closed; sent days can still be approved today; pay date {{pay_date}}',
          leave_override_granted: '{{granted_by}} gave you a pass on the leave rules: {{reason}}',
          approval_backlog_escalation: 'Overdue approvals were escalated',
          approval_backlog_digest: '{{row_count}} approvals are waiting past their deadline',
          approval_backlog_digest_both: '{{time_count}} time logs and {{leave_count}} leave requests are waiting past their deadline',
          approval_backlog_digest_time: '{{time_count}} time logs are waiting past their deadline',
          approval_backlog_digest_leave: '{{leave_count}} leave requests are waiting past their deadline',
          timesheet_backlog_expired: '{{count}} timesheet days of {{people}} people were rejected automatically, past the approval window',
          roster_departure_soon: 'You travel to {{project}} on {{start_date}}, in {{days_until}} day(s)',
          roster_plan_changed: 'Your published roster changed on {{change_count}} day(s), {{first_day}} to {{last_day}}',
          oreas_request_received: 'New OREAS request from {{company}}: {{products}}',
          oreas_request_resolved: '{{decided_by}} made a Draft quotation from the OREAS request by {{company}}',
          unknown: 'You have a new notification',
        },
        why: {
          actor: 'You got this because you made the change.',
          ability: 'You got this because you have the “{{label}}” permission.',
          level: 'You got this because you are on the {{level}} access level.',
          subject: {
            aboutYou: 'You got this because it is about you.',
            oreasHolder: 'You got this because you hold the OREAS tick or worked on this quotation.',
            yourRequest: 'You got this because you raised it.',
            youApprove: 'You got this because you approve it.',
            newSupervisor: 'You got this because you are the new supervisor.',
            overlap: 'You got this because it overlaps your leave.',
            applicantOrOverlap: 'You got this because it is your leave or overlaps yours.',
            overwork: 'You got this because it is about you or someone you supervise.',
            logsHours: 'You got this because you log hours.',
            pastEdit: 'You got this because it is your log or you approve logs.',
          },
        },
        open: 'Open', sentBy: 'Sent by rule',
        digestTime: 'Time logging ({{n}})', digestLeave: 'Leave ({{n}})',
        field: {
          leaveType: 'Leave type', statusBefore: 'Status before', decidedBy: 'Decided by', rejectedBy: 'Rejected by',
          changedBy: 'Changed by', reason: 'Reason', days: 'Days', cutoffDate: 'Cut-off date', payDate: 'Pay date',
          hours: 'Hours', before: 'Before', after: 'After', recipients: 'Sent to', endOfContract: 'Contract ends',
          resignationDate: 'Leaving date', previousSupervisor: 'Previous supervisor', newSupervisor: 'New supervisor',
          project: 'Project', grantedBy: 'Granted by', rule: 'Leave rule',
          peerLeaveType: 'Leave already booked', settlementFor: 'Settlement for', request: 'Request',
          daysRemaining: 'Days left', daysSinceEnd: 'Days since it ended',
        },
      },
      soon: { title: '{{app}} — coming soon', body: 'Replaces {{replaces}}. Pages for this section are being built.', module: 'This module is not built yet.' },
      month: { jan: 'Jan', feb: 'Feb', mar: 'Mar', apr: 'Apr', may: 'May', jun: 'Jun', jul: 'Jul', aug: 'Aug', sep: 'Sep', oct: 'Oct', nov: 'Nov', dec: 'Dec' },
      weekday: { mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun' },
      theme: { label: 'Theme', light: 'Light', dark: 'Dark', system: 'System' },
      profile: {
        title: 'Profile', name: 'Name', email: 'Email', accessLevel: 'Access level',
        language: 'Language',
        signatureHint: 'Used on the documents you sign.',
        signatureAbsent: 'No signature on file yet.', signatureUpload: 'Upload signature',
        signatureReplace: 'Replace', signatureRemove: 'Remove',
        signatureForbidden: 'You do not have permission to view this signature.',
        signatureBadType: 'PNG or JPEG only.',
        signatureHeic: 'iPhone photos (HEIC) are not supported: take a screenshot or export the image as PNG/JPEG.',
        signatureEmpty400: 'The file is empty.',
        signatureTooLarge: 'That file is too large (over 12 MB). Choose a smaller image; photos up to 12 MB are shrunk automatically.',
        signatureModeDraw: 'Draw a signature',
        signatureClear: 'Clear', signatureSave: 'Save',
        signatureEmpty: 'Draw a signature first.',
        signatureSlotAll: 'All document types',
        signatureSlotsHint: 'Add one for every document, or one per document type. A document uses its own type first.',
        signatureSlotFor: 'Used on',
        signatureSlotTaken: 'This slot already has a signature — a new one replaces it. Documents already issued keep the old one.',
        mySignature: 'My signature',
        // The signature switch.
        signatureSwitch: 'Sign documents with my signature',
        signatureSwitchOffHint:
          'Off: documents you issue print an empty signing line. Documents already issued keep their signature. Your images are not deleted.',
        // The break-glass self-elevation card. `elevateHint` says all
        // three true things at once -- temporary, revocable, recorded -- and
        // says "admin rights", never "full administrator": a grant never
        // writes `person.tier`, so impersonation stays shut.
        elevateTitle: 'Temporary admin rights',
        elevateHint:
          'If no administrator is reachable, you can give yourself admin rights for a fixed time. The window expires on its own, you can hand it back early, and every action you take under it is recorded against it.',
        elevateMinutes: 'For how long, in minutes',
        elevateMinutesHint: 'Up to {{max}} minutes ({{hours}} hours). There is no default — choose a length.',
        elevateReason: 'Reason',
        elevateReasonHint: 'At least {{min}} characters. Stored with the grant and shown in the audit log.',
        elevateButton: 'Give myself admin rights',
        elevateConfirmTitle: 'Give yourself admin rights?',
        elevateConfirmBody: 'You will hold admin rights for {{minutes}} minutes, after which they lapse on their own.',
        elevateConfirmAudited: 'This is recorded in the audit log with your reason, and you can hand the rights back at any time.',
        elevateConfirmOk: 'Yes, elevate me',
        elevateActive: 'You hold temporary admin rights until {{until}}.',
        elevateRemaining: '{{count}} minutes left',
        elevateActiveReason: 'Reason given: {{reason}}',
        elevateRevoke: 'Hand the rights back now',
        elevateGranted: 'You now hold temporary admin rights.',
        elevateRevoked: 'Admin rights handed back.',
      },
      nav: {
        groupInfo: 'Info', groupWork: 'Work', groupFinance: 'Finance', groupAdmin: 'Admin',
        expand: 'Keep menu open', collapse: 'Collapse menu',
        timeAwaiting: '{{count}} timesheet days awaiting your approval',
        leaveAwaiting: '{{count}} leave requests awaiting your decision',
        oreasAwaiting: '{{count}} OREAS requests and stock answers waiting for you',
        notificationsUnread: '{{count}} unread notifications',
      },
      action: {
        save: 'Save',
        moreAbout: 'About {{label}}',
        loading: 'Loading…',
        saveDraft: 'Draft',
        preview: 'Preview',
        refresh: 'Refresh',
        convert: 'Convert to invoice',
        clearFilters: 'Clear filters',
        collapse: 'Collapse',
        download: 'Download PDF',
        void: 'Void',
        delete: 'Delete',
        confirmDelete: 'Delete this?',
        deleteNamed: 'Delete "{{name}}"?',
        edit: 'Edit',
        cancel: 'Cancel',
        back: 'Back',
        newDocument: 'New document',
        showList: 'Show list',
        search: 'Search',
        close: 'Close',
        copy: 'Copy',
      },
      validation: {
        required: 'required',
        summaryTitle: 'Please fill in the required fields:',
        needLine: 'Add at least one item',
        itemDesc: 'Row {{rows}}: enter a description',
        enterClientInfo: 'Please enter the client info',
      },
      notImplemented: 'This module has not been ported yet.',
      error: { title: 'This page stopped working', pageStopped: '{{page}} stopped working', next: 'Reload to try again. If it happens again, send the details below to your administrator.', details: 'Error details', reload: 'Reload' },
  },
  ru: {
      app: { title: 'CenTrig', signOut: 'Выйти', signOutMicrosoft: 'Выйти и из Microsoft', signOutChoiceBody: 'Выйти только из этого приложения или также из Microsoft (Outlook и Teams в браузере)?', sessionCheckFailed: 'Не удалось связаться с сервером. Вы остаётесь в системе, данные на странице не потеряны.', sessionCheckRetry: 'Повторить', apiDownTitle: 'Нет связи с сервером', apiDownBody: 'Вы вошли через Microsoft, но API CenTrig не ответил. Это проблема сервера или соединения, а не вашей учётной записи. Убедитесь, что бэкенд запущен, и повторите попытку.', sales: 'Продажи', clients: 'Клиенты', priceList: 'Прайс-лист', activityExpense: 'Фонд мероприятий', requests: 'Заявки', trips: 'Командировки', users: 'Пользователи', salesDocuments: 'Документы',
        timeLogging: 'Табель', contractorLog: 'Журнал подрядчиков', leave: 'Отпуска', hotDesk: 'Бронь рабочего места', calendar: 'Календарь',
        mySalary: 'Моя зарплата', myInfo: 'Мои данные', mySupervisor: 'Мой руководитель', myEquipment: 'Моё оборудование',
        inventory: 'Инвентарь', laptops: 'Ноутбуки',
        adminActivities: 'Списки', adminCalendar: 'Календарь праздников', adminChanges: 'Журнал изменений',
        adminActions: 'Действия администратора', adminPersonTrail: 'След действий по сотруднику',
        adminAudit: 'Аудит',
        adminAuditLog: 'Доступ к зарплате', adminAutomation: 'Автоматизация', adminOrganization: 'Настройки организации',
        organization: 'Организация', hr: 'Кадры',
        me: 'Моя панель',
        dashboard: 'Панель управления',
        roster: 'График смен', schedule: 'График смен', rosterPeople: 'Сотрудники', bus: 'Автобус', hse: 'ОТ и ТБ', performance: 'Выработка', cost: 'Затраты', rosterSetup: 'Проекты', rosterMySchedule: 'Мой график',
        payroll: 'Зарплата', salary: 'Расчёт зарплаты' },
      dashboard: {
        last12: 'Последние 12 месяцев', noData: 'Нет данных',
        myAnnualLeave: 'Мой отпуск', daysRemaining: 'дней осталось',
        needsMe: 'Мой табель требует исправления', needsMeHint: 'отклонённые дни, неотправленные черновики -- не очередь на согласование',
        myPendingLeave: 'Мой отпуск на согласовании',
        myAwaiting: 'Отпуска на утверждение',
        myLeaves: 'Остаток отпуска',
        myPendingRejected: 'Мои часы: на проверке и отклонённые',
        superviseeHoursAwaiting: 'Часы подчинённых на проверке',
        pendingRequests: 'Мои заявки на закупку',
        myDesk: 'Место на сегодня',
        myTimesheet: 'Мой табель', thisMonth: 'Этот месяц', payrollPeriod: 'Расчётный период',
        approved: 'Утверждено', pending: 'На утверждении', draft: 'Черновик', rejected: 'Отклонено', missing: 'Не заполнено',
        weekend: 'Выходной', holiday: 'Праздник',
        ofWorkingDays: 'Из {{count}} рабочих дней',
        ofPeriodDays: 'Из {{count}} дней с {{date}}',
        myHoursByActivity: 'Мои часы по видам работ', myHoursByProduct: 'Мои часы по продуктам',
        myOpenItems: 'Мои прочие открытые дела', draftSales: 'Черновики продаж', unapprovedTrips: 'Неутверждённые командировки',
        activeStaff: 'Активных сотрудников', inactiveCount: '{{count}} неактивных',
        unapprovedDays: 'Неутверждённых дней', oldestDays: 'самый давний {{count}} дн. назад', unapprovedBand: '{{band}} дн.', unapprovedHelp: 'Все поданные и ещё не утверждённые дни, любой давности.', unapprovedOpenQueue: 'Очередь утверждения всех сотрудников',
        uncoveredProducts: 'Продукты без ответственных', uncoveredHint: 'никто не назначен',
        uncoveredList: 'Никто не назначен на: {{list}}',
        workModeNow: 'Режимы работы сегодня',
        genderRatio: 'Соотношение полов', genderFullTime: 'Полный день',
        hoursByProduct: 'Часы по продуктам', thisMonthCompany: 'Текущий месяц, все сотрудники',
        byTeam: 'По командам', byWorkType: 'По типу занятости',
        productCoverage: 'Охват продуктов', productCoverageHint: 'Назначено людей', chartOther: 'Прочее',
        roleMix: 'Распределение ролей',
      },
      notifications: {
        myTitle: 'Мои уведомления', hint: 'История автоматических уведомлений, адресованных вам',
        empty: 'Пока нет уведомлений', error: 'Не удалось загрузить уведомления', markAllRead: 'Отметить все как прочитанные',
        unreadCount: '{{count}} непрочитанных', loadMore: 'Загрузить ещё',
        popupTitle: 'Что нового', popupViewAll: 'Смотреть все', popupDismiss: 'Закрыть', morePeople: 'ещё {{count}}',
        kind: {
          invoice_due_soon: 'Счёт {{document_no}} для {{organization}} должен быть оплачен {{due_date}} ({{total}} {{currency}})',
          invoice_overdue: 'Счёт {{document_no}} для {{organization}} просрочен (срок был {{due_date}})',
          contract_end_soon: 'Договор {{name}} заканчивается {{end_of_contract}}',
          contract_end_past: 'Договор {{name}} закончился {{end_of_contract}}',
          hr_welcome: 'Добро пожаловать, {{first_name}} — начал(а) работу {{worked_since}}',
          hr_anniversary: '{{years}}-летняя годовщина работы {{name}}',
          hr_birthday: 'День рождения {{name}}',
          supervisor_changed: 'Руководитель {{name}} изменился с {{previous_supervisor}} на {{new_supervisor}}',
          staff_joined: '{{name}}: приём в компанию',
          staff_left: '{{name}}: уход из компании',
          request_submitted: '{{type_of}} от {{prepared_by}}: {{purpose}} ({{total}} {{currency}})',
          request_decided: '{{type_of}} "{{purpose}}" — статус: {{approval_status}} ({{editor}})',
          equipment_request_decided: 'Ваша заявка на оборудование: {{status}} ({{decided_by}})',
          request_self_approved: '{{editor}} сам утвердил свою заявку {{type_of}} "{{purpose}}" ({{total}} {{currency}})',
          request_sent: '{{editor}} отправил(а) заявку {{type_of}} "{{purpose}}" от {{prepared_by}} ({{total}} {{currency}})',
          timesheet_needs_approval: 'Табели подчинённых ожидают вашего утверждения',
          timesheet_rejected: 'Ваша запись табеля отклонена',
          timesheet_rejected_day: 'Ваша запись табеля за {{date}} отклонена',
          timesheet_rejected_expired: 'Запись табеля за {{date}} не была утверждена вовремя и отклонена системой автоматически',
          timesheet_rejected_more: 'Ещё {{more}} записей табеля отклонены, самая ранняя — за {{date}}',
          timesheet_office_solo_late: '{{actor}} единолично изменил(а) просроченный день {{day}} сотрудника {{name}} без совместных согласований',
          timesheet_past_edit: '{{actor}} исправил(а) прошедший день {{day}} в табеле сотрудника {{name}}',
          timesheet_late_submitted: '{{name}} отправил(а) {{day}} ({{hours}} ч) на утверждение после отсечки {{period}}; оплата в {{paid_in}}',
          timesheet_past_edit_mailed: 'Уведомление об исправлении дня {{day}} сотрудника {{name}} отправлено по почте: {{recipients}}',
          salary_cutoff_pending: 'Есть неотправленные часы до закрытия расчёта {{cutoff_date}}',
          salary_cutoff_last_day: 'Ввод часов для расчёта {{cutoff_date}} закрывается сегодня в 12:00',
          timesheet_approval_deadline: 'Утвердите сегодня ожидающие дни подчинённых для расчёта {{cutoff_date}}',
          timesheet_pending_at_close: 'Для расчёта {{cutoff_date}} не утверждено дней: {{pending_count}}',
          timesheet_weekly_reminder: 'Заполните табель за эту неделю',
          annual_leave_unused: 'Обязательный ежегодный отпуск ещё не использован',
          leave_break_ending: '{{leave_type}} сотрудника {{employee_name}} заканчивается {{end_date}}, через неделю',
          leave_break_starting: '{{employee_name}} уходит в перерыв с {{start_date}} по {{end_date}}: {{leave_type}}',
          leave_approval_pending: 'Заявка на отпуск ожидает вашего согласования',
          leave_submitted: '{{employee_name}} подал(а) заявку {{leave_type}}: {{start_date}}–{{end_date}} ({{days}} дн.)',
          leave_decided: 'Ваша заявка {{leave_type}} ({{start_date}}–{{end_date}}) — {{status}} ({{decided_by}})',
          leave_peer_blocked: 'Ваш {{leave_type}} {{start_date}}–{{end_date}} отклонён: {{peer_name}} в отпуске {{peer_start}}–{{peer_end}} ({{peer_status}})',
          leave_peer_clash: '{{leave_type}} {{start_date}}–{{end_date}} сотрудника {{applicant_name}} отклонён, так как пересекается с вашим отпуском {{peer_start}}–{{peer_end}}',
          leave_rule_overridden: '{{overridden_by}} обошёл правило «{{rule}}» для {{leave_type}} {{start_date}}–{{end_date}} сотрудника {{employee_name}}: {{reason}}',
          leave_cancel_refused: '{{decided_by}} отклонил(а) отзыв {{leave_type}} {{start_date}}–{{end_date}}',
          leave_cancelled: '{{cancelled_by}} отменил(а) {{leave_type}} {{start_date}}–{{end_date}} сотрудника {{employee_name}}; ваше утверждение больше не нужно',
          leave_settlement_decided: 'Ваш расчёт за отпуск ({{requested_days}} дн.) — {{status}}, решение: {{decided_by}}',
          leave_auto_rejected: 'Ваша заявка {{leave_type}} {{start_date}}–{{end_date}} отклонена автоматически: прошло более двух расчётных периодов',
          overwork_14_days: '{{name}} работает 14 дней подряд без выходного',
          resignation_today: '{{name}} сегодня ({{resignation_date}}) уходит из компании',
          salary_cutoff_reminder: 'Закрытие расчёта зарплаты: {{cutoff_date}}',
          salary_cutoff_moved: 'Закрытие расчёта зарплаты перенесено с {{previous_cutoff_date}} на {{cutoff_date}}',
          salary_cutoff_closed: 'Ввод часов для расчёта {{cutoff_date}} закрыт; отправленные дни можно утвердить сегодня; дата выплаты {{pay_date}}',
          leave_override_granted: '{{granted_by}} разрешил(а) вам исключение из правил отпуска: {{reason}}',
          approval_backlog_escalation: 'Просроченные согласования переданы выше',
          approval_backlog_digest: 'Согласований, ждущих дольше срока: {{row_count}}',
          approval_backlog_digest_both: 'Ждут дольше срока: табели — {{time_count}}, заявки на отпуск — {{leave_count}}',
          approval_backlog_digest_time: 'Табелей, ждущих дольше срока: {{time_count}}',
          approval_backlog_digest_leave: 'Заявок на отпуск, ждущих дольше срока: {{leave_count}}',
          timesheet_backlog_expired: 'Автоматически отклонено дней табеля после окна согласования: {{count}} (сотрудников: {{people}})',
          roster_departure_soon: 'Вы выезжаете на {{project}} {{start_date}}, через {{days_until}} дн.',
          roster_plan_changed: 'Ваш опубликованный график изменён: дней {{change_count}}, {{first_day}} — {{last_day}}',
          oreas_request_received: 'Новая заявка OREAS от {{company}}: {{products}}',
          oreas_request_resolved: '{{decided_by}} создал(а) черновик предложения по заявке OREAS от {{company}}',
          unknown: 'Новое уведомление',
        },
        why: {
          actor: 'Вы получили это, потому что внесли изменение.',
          ability: 'Вы получили это, потому что у вас есть право «{{label}}».',
          level: 'Вы получили это, потому что у вас уровень доступа {{level}}.',
          subject: {
            aboutYou: 'Вы получили это, потому что это касается вас.',
            oreasHolder: 'Вы получили это, потому что у вас есть доступ OREAS или вы работали с этим предложением.',
            yourRequest: 'Вы получили это, потому что это ваша заявка.',
            youApprove: 'Вы получили это, потому что вы это утверждаете.',
            newSupervisor: 'Вы получили это, потому что вы новый руководитель.',
            overlap: 'Вы получили это, потому что это пересекается с вашим отпуском.',
            applicantOrOverlap: 'Вы получили это, потому что это ваш отпуск или он пересекается с вашим.',
            overwork: 'Вы получили это, потому что это касается вас или вашего подчинённого.',
            logsHours: 'Вы получили это, потому что вы ведёте учёт времени.',
            pastEdit: 'Вы получили это, потому что это ваш табель или вы утверждаете табели.',
          },
        },
        open: 'Открыть', sentBy: 'Правило рассылки',
        digestTime: 'Табель ({{n}})', digestLeave: 'Отпуска ({{n}})',
        field: {
          leaveType: 'Тип отпуска', statusBefore: 'Прежний статус', decidedBy: 'Решение принял(а)', rejectedBy: 'Отклонил(а)',
          changedBy: 'Изменил(а)', reason: 'Причина', days: 'Дней', cutoffDate: 'Дата закрытия', payDate: 'Дата выплаты',
          hours: 'Часы', before: 'До', after: 'После', recipients: 'Получатели', endOfContract: 'Окончание договора',
          resignationDate: 'Дата ухода', previousSupervisor: 'Прежний руководитель', newSupervisor: 'Новый руководитель',
          project: 'Проект', grantedBy: 'Выдал(а)', rule: 'Правило отпуска',
          peerLeaveType: 'Уже оформленный отпуск', settlementFor: 'Основание расчёта', request: 'Заявка',
          daysRemaining: 'Осталось дней', daysSinceEnd: 'Дней после окончания',
        },
      },
      soon: { title: '{{app}} — скоро', body: 'Заменит {{replaces}}. Страницы этого раздела в разработке.', module: 'Этот модуль ещё не готов.' },
      month: { jan: 'янв', feb: 'фев', mar: 'мар', apr: 'апр', may: 'май', jun: 'июн', jul: 'июл', aug: 'авг', sep: 'сен', oct: 'окт', nov: 'ноя', dec: 'дек' },
      weekday: { mon: 'Пн', tue: 'Вт', wed: 'Ср', thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс' },
      theme: { label: 'Тема', light: 'Светлая', dark: 'Тёмная', system: 'Системная' },
      profile: {
        title: 'Профиль', name: 'Имя', email: 'Эл. почта', accessLevel: 'Уровень доступа',
        language: 'Язык',
        signatureHint: 'Используется в документах, которые вы подписываете.',
        signatureAbsent: 'Подпись ещё не загружена.', signatureUpload: 'Загрузить подпись',
        signatureReplace: 'Заменить', signatureRemove: 'Удалить',
        signatureForbidden: 'У вас нет доступа для просмотра этой подписи.',
        signatureBadType: 'Только PNG или JPEG.',
        signatureHeic: 'Фото iPhone (HEIC) не поддерживаются: сделайте снимок экрана или экспортируйте изображение в PNG/JPEG.',
        signatureEmpty400: 'Файл пустой.',
        signatureTooLarge: 'Файл слишком большой (больше 12 МБ). Выберите изображение поменьше; фото до 12 МБ уменьшаются автоматически.',
        signatureModeDraw: 'Нарисовать подпись',
        signatureClear: 'Очистить', signatureSave: 'Сохранить',
        signatureEmpty: 'Сначала нарисуйте подпись.',
        signatureSlotAll: 'Все типы документов',
        signatureSlotsHint: 'Добавьте одну подпись для всех документов или по одной на каждый тип. Документ сначала берёт подпись своего типа.',
        signatureSlotFor: 'Для документов',
        signatureSlotTaken: 'Для этого типа подпись уже есть — новая заменит её. Уже выставленные документы сохранят прежнюю.',
        mySignature: 'Моя подпись',
        // The signature switch.
        signatureSwitch: 'Подписывать документы моей подписью',
        signatureSwitchOffHint:
          'Выключено: в выставляемых вами документах печатается пустая строка для подписи. Уже выставленные документы сохраняют подпись. Изображения не удаляются.',
        elevateTitle: 'Временные права администратора',
        elevateHint:
          'Если ни один администратор недоступен, вы можете выдать себе права администратора на определённое время. Окно истекает само, вы можете вернуть права раньше, и каждое действие под ними записывается.',
        elevateMinutes: 'На сколько, в минутах',
        elevateMinutesHint: 'До {{max}} минут ({{hours}} часов). Значения по умолчанию нет — выберите срок сами.',
        elevateReason: 'Причина',
        elevateReasonHint: 'Не менее {{min}} символов. Сохраняется вместе с выдачей и видна в журнале аудита.',
        elevateButton: 'Выдать себе права администратора',
        elevateConfirmTitle: 'Выдать себе права администратора?',
        elevateConfirmBody: 'Вы получите права администратора на {{minutes}} минут, после чего они истекут сами.',
        elevateConfirmAudited: 'Это записывается в журнал аудита вместе с указанной причиной, и вы можете вернуть права в любой момент.',
        elevateConfirmOk: 'Да, выдать права',
        elevateActive: 'У вас есть временные права администратора до {{until}}.',
        elevateRemaining: 'Осталось {{count}} минут',
        elevateActiveReason: 'Указанная причина: {{reason}}',
        elevateRevoke: 'Вернуть права сейчас',
        elevateGranted: 'Теперь у вас временные права администратора.',
        elevateRevoked: 'Права администратора возвращены.',
      },
      nav: {
        groupInfo: 'Информация', groupWork: 'Работа', groupFinance: 'Финансы', groupAdmin: 'Администрирование',
        expand: 'Закрепить меню', collapse: 'Свернуть меню',
        timeAwaiting: 'Дней в табеле на вашем утверждении: {{count}}',
        leaveAwaiting: 'Заявок на отпуск ждут вашего решения: {{count}}',
        oreasAwaiting: 'Заявки OREAS и вопросы по запасу ждут вашего ответа: {{count}}',
        notificationsUnread: '{{count}} непрочитанных уведомлений',
      },
      action: {
        save: 'Сохранить',
        moreAbout: 'Подробнее: {{label}}',
        loading: 'Загрузка…',
        saveDraft: 'Черновик',
        preview: 'Предпросмотр',
        refresh: 'Обновить',
        convert: 'В инвойс',
        clearFilters: 'Сбросить фильтры',
        collapse: 'Свернуть',
        download: 'Скачать PDF',
        void: 'Аннулировать',
        delete: 'Удалить',
        confirmDelete: 'Удалить?',
        deleteNamed: 'Удалить «{{name}}»?',
        edit: 'Изменить',
        cancel: 'Отмена',
        back: 'Назад',
        newDocument: 'Новый документ',
        showList: 'Показать список',
        search: 'Поиск',
        close: 'Закрыть',
        copy: 'Копировать',
      },
      validation: {
        required: 'обязательно',
        summaryTitle: 'Заполните обязательные поля:',
        needLine: 'Добавьте хотя бы одну строку',
        itemDesc: 'Строка {{rows}}: введите наименование',
        enterClientInfo: 'Пожалуйста, укажите данные клиента',
      },
      notImplemented: 'Этот модуль ещё не перенесён.',
      error: { title: 'Эта страница перестала работать', pageStopped: '{{page}}: страница перестала работать', next: 'Перезагрузите страницу. Если ошибка повторится, отправьте подробности ниже администратору.', details: 'Подробности ошибки', reload: 'Перезагрузить' },
  },
}
